import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.OPERATIONS}`;

async function fetchVehicleOperations(filters = {}) {
  try {
    const payload = {
      LicensePlate: filters.LicensePlate || filters.licensePlate || "",
      Doc: filters.Doc || filters.doc || "",
      CustomerName: filters.CustomerName || filters.customerName || "",
    };

    const query = new URLSearchParams(
      Object.entries(payload).filter(([, value]) => value !== "")
    ).toString();

    const url = query ? `${basePath}?${query}` : basePath;

    const response = await api.get(url);

    const treated = errorHandling.handleResponse(
      response,
      "operationsService.fetchVehicleOperations"
    );

    if (treated) {
      return treated;
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "operationsService.fetchVehicleOperations");
    return null;
  }
}

async function fetchVehicleOperationById(id) {
  try {
    if (!id && id !== 0) {
      return null;
    }

    const url = `${basePath}/${id}`;
    const response = await api.get(url);

    const treated = errorHandling.handleResponse(
      response,
      "operationsService.fetchVehicleOperationById"
    );

    if (treated) {
      return treated;
    }

    return null;
  } catch (error) {
    errorHandling.cathError(error, "operationsService.fetchVehicleOperationById");
    return null;
  }
}

export const operationsService = {
  fetchVehicleOperations,
  fetchVehicleOperationById,
};
